<div class="inicio">
  <form #insertForm="ngForm"  [formGroup]="formDetSolicitud" >

      <p class="titulo">SOLICITUD DE {{tipoSolicitud}} </p>
        <div class="grid-containerB" >
          <button mat-mini-fab style="background-color: #00c030d0;  color: white;" (click)="goBack()"> <span class="material-icons">undo</span> </button>
        </div>
      <div class="grid-container2">
        <div class="celda">
            <mat-label class="label" >Tipo de solicitud</mat-label>
            <mat-form-field appearance="outline">
                <input matInput type="text" placeholder="Tipo se solicitud" formControlName="tipoSolicitud" readonly/>
            </mat-form-field>
        </div>
      </div>
      <!--DATOS DEL COLABORADOR-->
      <p></p><h3>DATOS DEL COLABORADOR</h3>
      <div class="div" >
         <!--Nombre del colaborador-->
         <div class="grid-container">
          <div class="celda">
              <mat-label class="label"> Nombre del colaborador </mat-label>
              <mat-form-field appearance="outline">
                  <input matInput type="text" placeholder="Nombre del colaborador" formControlName="colaborador" readonly />
              </mat-form-field>
          </div>
         </div>
        <!--Cargo y sucursal/oficina-->
        <div class="grid-container2">
          <!--Cargo-->
          <div class="celda">
              <mat-label class="label"> Cargo </mat-label>
              <mat-form-field appearance="outline">
                <input matInput type="text" placeholder="No se encontró este campo" formControlName="puesto" readonly />
              </mat-form-field>
          </div>

          <!--Oficina/Sucursal-->
          <div class="celda">
              <mat-label class="label"> Sucursal </mat-label>
              <mat-form-field appearance="outline">
                  <input matInput type="text" placeholder="No se encontró este campo" formControlName="sucursal"readonly />
              </mat-form-field>
          </div>
        </div>
      </div>
      <p></p>
      <div class="div">

         <!--Reemplazo-->
         <div class="grid-container"  >
          <div class="celda"  >
              <mat-label class="label"> ¿Cuenta con reemplazo? </mat-label>
              <mat-form-field appearance="outline">
                <input matInput type="text" placeholder="¿Cuenta con reemplazo?" formControlName="reemplazo" readonly/>
              </mat-form-field>
          </div>
        </div>
        <!--Cargo y sucursal/oficina-->
        <P></P>

      </div>
       <!--DATOS DEL SOLICITANTE-->
       <p></p><h3>DATOS DEL SOLICITANTE</h3>
       <div class="div">
          <!--Nombre del colaborador-->
          <div class="grid-container">
           <div class="celda">
               <mat-label class="label"> Nombre del solicitante </mat-label>
               <mat-form-field appearance="outline">
                   <input matInput type="text" placeholder="No se encontró este campo" formControlName="solicitante" readonly/>
               </mat-form-field>
           </div>
          </div>
         <!--Cargo y sucursal/oficina-->
         <div class="grid-container2">
           <!--Cargo-->
           <div class="celda">
               <mat-label class="label"> Cargo </mat-label>
               <mat-form-field appearance="outline">
                 <input matInput type="text" placeholder="No se encontró este campo" formControlName="puesto_solicitante" readonly />
               </mat-form-field>
           </div>

           <!--Oficina/Sucursal-->
           <div class="celda">
               <mat-label class="label"> Sucursal </mat-label>
               <mat-form-field appearance="outline">
                   <input matInput type="text" placeholder="No se encontró este campo" formControlName="sucursal_solicitante" readonly />
               </mat-form-field>
           </div>
         </div>
          <!--email-->
          <div class="grid-container"  >
           <div class="celda"   >
               <mat-label class="label"> Email </mat-label>
               <mat-form-field appearance="outline">
                 <input matInput type="text" placeholder="No se encontró este campo" formControlName="email_solicitante" readonly/>
               </mat-form-field>
           </div>
         </div>
       </div>
       <!--DATOS GNERALES DE LOS PRIVILEGIOS-->
       <p></p><h3>DATOS GENERALES</h3>


       <div class="div">
         <!--TABLAS DE SERVICIOS SOLICITADOS-->
          <div  class="grid-container"  >

            <!--TABLA PARA ACTIVACION------------------------------------------------------------------------->
            <div class="grid-container" *ngIf="statusSolicitud=='Espera' && banderaE !='true' " >
              <mat-label class="grid-container" class="label"  > SERVICIOS A SUSPENDER ELEGIDOS POR EL SOLICITANTE</mat-label>

              <table mat-table [dataSource] = "dataSourceSusp"  class="mat-elevation-z8" class="tableServiciosActivados"  >

                <ng-container matColumnDef="c1">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE DEL SERVICIO </th>
                    <td mat-cell *matCellDef="let element"> {{element.nombre_servicio}} </td>
                </ng-container>
                <ng-container matColumnDef="c2">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> USUARIO </th>
                  <td mat-cell *matCellDef="let element">{{element.usuario}} </td>
                </ng-container>
                <ng-container matColumnDef="c3">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> PASSWORD </th>
                  <td mat-cell *matCellDef="let element"> {{element.contrasenia}}  </td>
                </ng-container>
                <ng-container matColumnDef="c4">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> SUCURSAL </th>
                  <td mat-cell *matCellDef="let element"> {{element.nomSucursalCol}} </td>
                </ng-container>
                <ng-container matColumnDef="c5">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> {{cabeceraCheck}} SERVICIO </th>
                  <td mat-cell *matCellDef="let element">
                      <mat-checkbox [(ngModel)]="element.status_reg" [ngModelOptions]="{standalone: true}"  ></mat-checkbox>
                      <span *ngIf="element.status_reg==true" ></span>
                  </td>
                </ng-container>


                <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
                <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>
                <h2></h2>

              </table>
              <p></p>
            </div>

             <!--TABLA DE TODOS LOS SERVICIOS ACTIVOS CON LOS QUE CUENTA EL COLABORADOR------------------------------------------------------------------------->
            <div class="div2" *ngIf="statusSolicitud=='Espera' && banderaE !='true' ">
              <mat-label class="grid-container" class="label"  > SERVICIOS ACTIVOS CON LOS QUE CUENTA EL COLABORADOR</mat-label>

              <div class="grid-container"  >
                <div class="grid-container2">
                  <mat-form-field>
                    <mat-label>BUSCAR</mat-label>
                    <input matInput  (keyup)="applyFilter($event)"  placeholder="INGRESE DATO A BUSCAR">
                  </mat-form-field>
                </div>

                <table mat-table [dataSource] = "dataSourceActivados"  class="mat-elevation-z8">
                  <ng-container matColumnDef="c1">
                      <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE DEL SERVICIO </th>
                      <td mat-cell *matCellDef="let element"> {{element.nombre_servicio}} </td>
                  </ng-container>
                  <ng-container matColumnDef="c2">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> USUARIO </th>
                    <td mat-cell *matCellDef="let element">{{element.usuario}} </td>
                  </ng-container>
                  <ng-container matColumnDef="c3">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> PASSWORD </th>
                    <td mat-cell *matCellDef="let element"> {{element.contrasenia}}  </td>
                  </ng-container>
                  <ng-container matColumnDef="c4">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> SUCURSAL </th>
                    <td mat-cell *matCellDef="let element"> {{element.nomSucursalCol}} </td>
                  </ng-container>
                  <ng-container matColumnDef="c5">
                    <!--Check para seleccionar todo--
                    <th mat-header-cell *matHeaderCellDef mat-sort-header> {{cabeceraCheck}} SERVICIO </th>-->

                    <th mat-header-cell *matHeaderCellDef>
                      <div class="example-button-row">
                          <mat-checkbox class="example-margin" *ngIf="this.dataSourceActivados.data.length>0" (change)="selectAllCheck($event.checked)" ></mat-checkbox>
                      </div>
                    </th>
                    <td mat-cell *matCellDef="let element">
                        <mat-checkbox [(ngModel)]="element.status_reg" [ngModelOptions]="{standalone: true}"  ></mat-checkbox>
                        <span *ngIf="element.status_reg==true" ></span>
                    </td>
                  </ng-container>

                  <tr mat-header-row *matHeaderRowDef="encabezadostabla"></tr>
                  <tr mat-row *matRowDef="let row; columns: encabezadostabla;"></tr>
                  <h2></h2>
                </table>
                <mat-paginator class="mat-elevation-z8" [pageSizeOptions]="[10, 20, 30, 40, 50]" showFirstLastButtons></mat-paginator>
                <p></p>
              </div>
            </div>

          </div> <!--CIERRE DE LAS TABLAS DE SERVICIOS SOLICITADOS-->
           <!--DETALLE DE LOS SERVICIOS DE UNA SOLICITUD ATENDIDA  -->
          <div class="grid-tabla" *ngIf="statusSolicitud=='Atendido' || statusSolicitud=='Cancelado' || banderaE=='true' " >
            <mat-label class="label"> SERVICIOS </mat-label>

              <!--Tabla-->
            <table mat-table [dataSource] = "dataAtendidos"  class="mat-elevation-z8">
              <ng-container matColumnDef="c1">
                  <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE DEL SERVICIO </th>
                  <td mat-cell *matCellDef="let element"> {{element.nombre_servicio}} </td>
              </ng-container>
              <ng-container matColumnDef="c2">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> ESTATUS DEL SERVICIO </th>
                <td mat-cell *matCellDef="let element"> {{element.status_serv}} </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="encabezadostabAtendidos"></tr>
              <tr mat-row *matRowDef="let row; columns: encabezadostabAtendidos;"></tr>
            </table>
          </div>

          <br><br>
          <!--TABLA DE SERVICIOS SUSPENDIDOS, SOLICITUD ANTENDIDA-->
        <div class="grid-tabla" *ngIf="statusSolicitud=='Atendido' " >
          <mat-label class="grid-container" class="label"  > SERVICIOS SUSPENDIDOS DE ESTA SOLICITUD</mat-label>
          <table mat-table [dataSource] = "dataServSusp"  class="mat-elevation-z8">

            <ng-container matColumnDef="c1">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> NOMBRE DEL SERVICIO </th>
                <td mat-cell *matCellDef="let element"> {{element.detalleSolicitud.tipo_servicio.nombre_servicio}} </td>
            </ng-container>
            <ng-container matColumnDef="c2">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> USUARIO </th>
              <td mat-cell *matCellDef="let element"> {{element.usuario}}</td>

            </ng-container>
            <ng-container matColumnDef="c3">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> PASSWORD </th>
              <td mat-cell *matCellDef="let element"> {{element.contrasenia}}  </td>
            </ng-container>
            <ng-container matColumnDef="c4">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> SUCURSAL </th>
              <td mat-cell *matCellDef="let element"> {{element.nomSucursalCol}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="encabezadostabla4"></tr>
            <tr mat-row *matRowDef="let row; columns: encabezadostabla4;"></tr>
            <h2></h2>
          </table>
          <br>
        </div>


          <P></P>
          <div  >

            <div class="grid-container">
              <mat-label class="label">Tipo</mat-label>
                <mat-form-field appearance="outline">
                  <input matInput type="text" placeholder="Temporal o permanente" formControlName="tipo" readonly />
                </mat-form-field>
            </div>
            <p></p><p></p>
            <div class="grid-container" *ngIf="tipoSeleccionado('Temporal'); ">
              <mat-label class="label"> Fecha de alta - Fecha de baja </mat-label>
              <mat-form-field appearance="fill">
                <mat-label> Fecha de alta - Fecha de baja </mat-label>
                <mat-date-range-input [formGroup]="range" >
                  <input matStartDate formControlName="fecha_alta" placeholder="Start date" readonly >
                  <input matEndDate formControlName="fecha_baja" placeholder="End date" readonly>
                </mat-date-range-input>
              </mat-form-field>

            </div>

          </div>

          <!--Comentarios-->
          <div class="grid-container">
              <div class="celda">
                 <!-- <mat-label class="label" *ngIf="tipoSeleccionado('Temporal')==false || tipoSoliSeleccionada('SUSPENSIÓN DE SERVICIOS')==false; "  >Comentarios</mat-label>
                  <mat-label class="label" *ngIf="tipoSeleccionado('Temporal') && tipoSoliSeleccionada('SUSPENSIÓN DE SERVICIOS'); " >Motivo de la suspención temporal </mat-label>
                -->
                <mat-label class="label" *ngIf="tipoSeleccionado('Temporal')==false "  >Comentarios</mat-label>
                <mat-label class="label" *ngIf="tipoSeleccionado('Temporal') " >Motivo de la suspención temporal </mat-label>

                  <mat-form-field class="example-full-width" appearance="outline">
                      <textarea matInput placeholder="Comentarios" formControlName="comentarios" readonly   ></textarea>
                  </mat-form-field>
              </div>
          </div>
        </div>

      <p></p>
      <!--Botones-->
      <div class="grid-container2" *ngIf="statusSolicitud=='Espera' && banderaE !='true' ">
        <!--Boton guaradar-->
        <button  type="submit" mat-raised-button color="primary" (click)="generarDetalleSolicitudSusp()" >Aceptar</button>
        <!--Boton cancelar-->
        <button mat-raised-button color="warn" (click)="rechazarSolicitud()" >Rechazar solicitud<mat-icon>cancel</mat-icon></button>
      </div>
      <div class="wrapper" *ngIf="statusSolicitud=='Atendido' || statusSolicitud=='Cancelado' || banderaE=='true' " >
        <button mat-raised-button style="background-color: #00c030d0; width:350px; color: white;" (click)="goBack()" >Aceptar<mat-icon>done_all</mat-icon></button>
      </div>

  </form>
</div>
